import {
  PersonalXFromCommunityData,
  TableCellAttribute,
  TableCellStyles,
  TableDataAdaptee,
  TableHeadData,
  TableRowData,
} from 'src/app/interfaces/tables.interfaces';
import { PendingUserInvolvementInCommunity } from 'src/app/swagger-api';
import {
  manageCommunityTableHead,
  personalUserXRowData,
  userInvitesTableCellAttributes,
} from '../table-users-list.data';
import { tableComponentStyles } from './table.styles';

export class PersonalUserInvitesFromCommunityTableDataAdaptee implements TableDataAdaptee {
  public constructor(private dictionary: PersonalXFromCommunityData) {}

  public getTableHeadData(): TableHeadData[] {
    return manageCommunityTableHead;
  }

  public getCellAttributes(): TableCellAttribute[] {
    return userInvitesTableCellAttributes;
  }

  public getCellStyles(): TableCellStyles {
    return tableComponentStyles.tableWithDateAndManage;
  }

  public createTableBody(): TableRowData[] {
    return this.dictionary.personalEntities.map((request: PendingUserInvolvementInCommunity, id: number) =>
      personalUserXRowData(id, request, this.dictionary.actorId, true),
    );
  }
}
